import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";

import { ProductReviewFragment, VoteOnReviewDocument } from "../../common/gql/graphql";
import { DataService } from "../../../core/providers/data/data.service";
import { StorageService } from "../../../core/providers/storage/storage.service";
import { Nl2brPipe } from "../../../shared/pipes/nl2br.pipe";
import { UppercaseFirstPipe } from "../../../shared/pipes/uppercase-first.pipe";
import { NgxPaginationModule } from "ngx-pagination";
import { PaginationComponent } from "../../../shared/components/pagination/pagination.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { StarRatingComponent } from "../../../shared/components/star-rating/star-rating.component";
import { NgFor, NgIf, DatePipe } from "@angular/common";
import { faEye } from "@fortawesome/free-solid-svg-icons";


@Component({
    selector: 'kb-product-review-list',
    templateUrl: './product-review-list.component.html',
    styleUrls: ['./product-review-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgFor,
        StarRatingComponent,
        NgIf,
        FontAwesomeModule,
        PaginationComponent,
        DatePipe,
        NgxPaginationModule,
        UppercaseFirstPipe,
        Nl2brPipe,
    ],
})
export class ProductReviewListComponent {
    constructor(private dataService: DataService,
                private changeDetector: ChangeDetectorRef,
                private storageService: StorageService) {}

    @Input() reviews: ProductReviewFragment[];
    @Input() itemsPerPage: number;
    @Input() totalItems: number;
    @Input() currentPage: number;
    @Output() pageChange = new EventEmitter<number>();
    private justVotedOn: string[] = [];
    check = faEye;

    hasVotedOnReview(id: string): boolean {
        const votedOn = this.getVotedOnReviewIds();
        return votedOn.includes(id);
    }

    hasJustVotedOn(id: string): boolean {
        return this.justVotedOn.includes(id);
    }

    upvote(id: string) {
        this.voteOnReview(id, true);
    }

    downvote(id: string) {
        this.voteOnReview(id, false);
    }

    private voteOnReview(id: string, helpful: boolean) {
        this.dataService.mutate(VoteOnReviewDocument, {
            id,
            helpful,
        }).subscribe(data => {
            const review = this.reviews.find(r => r.id === id);
            Object.assign({}, review, data.voteOnReview);
            this.setAsVotdOn(id);
            this.changeDetector.markForCheck();
        });
    }

    private setAsVotdOn(id: string) {
        const currentIds = this.getVotedOnReviewIds();
        currentIds.push(id);
        this.storageService.setInLocalStorage('votedOnReviews', currentIds.join('|'));
        this.justVotedOn.push(id);
    }

    private getVotedOnReviewIds(): string[] {
        const storedValue = this.storageService.getFromLocalStorage('votedOnReviews');
        return storedValue ? storedValue.split('|') : [];
    }

}
